<template>
    <div role="main" class="main lecture">
        <div v-if="ready==false" class="mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto text-center">
                        <spring-spinner
                        :animation-duration="5000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container">
                <div class="row mt-3">
                    <div class="col-sm-12 mx-md-auto text-center">
                        <h2 class="font-weight-normal text-9 text-uppercase justify-center mb-3 pb-3 pt-2">Presentations</h2>
                    </div>
                </div>
                <div class="row mt-3 presentation">
                    <div class="col-sm-12 col-lg-6">
                        <p class="font-weight-bold text-6 text-uppercase"> 
                            {{ lecture[0].lecture_title }}
                        </p>
                        <div class="biography text-4 text-justify" v-html="lecture[0].description"></div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                        <div v-html="lecture[0].media"></div>
                        <div class="actions">
                            <a v-if="show_rate" :href="'/lectures/'+details+'/rate'">Rate lecture</a>
                            <a v-if="show_points && lecture[0].nokia_points != null" :href="lecture[0].nokia_points">Nokia Learning Points</a>
                        </div>
                        <div class="files mt-3" v-if="lecture[0].slides">
                            <span class="text-6">Download files >></span> 
                            <a :href="lecture[0].slides"><span class="icon " :class="lecture[0].ext">Download</span></a>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12 mx-md-auto text-center">
                        <h2 class="font-weight-normal text-9 text-uppercase justify-center mb-3 pb-3 pt-2">Speakers</h2>
                    </div>
                </div>
                <div class="row mt-3" v-for="a in author" :key="a.id">
                    <div class="col-sm-12 col-lg-3">
                        <img :src="a.image_full_url" alt="">
                        <div class="social mt-4 mb-4">
                            <span class="thumb-info-social-icons">
                                <a v-if="a.facebook && a.show_facebook == true" :href="a.facebook"><i class="fab fa-facebook-f"></i><span>Facebook</span></a>
                                <a v-if="a.twitter && a.show_twitter == true" :href="a.twitter"><i class="fab fa-twitter"></i><span>Twitter</span></a>
                                <a v-if="a.youtube && a.show_youtube == true" :href="a.youtube"><i class="fab fa-youtube"></i><span>Youtube</span></a>
                                <a v-if="a.github && a.show_github == true" :href="a.github"><i class="fab fa-github"></i><span>Github</span></a>
                                <a v-if="a.linkedin && a.show_linkedin == true" :href="a.linkedin"><i class="fab fa-linkedin-in"></i><span>Linkedin</span></a>
                                <a v-if="a.email && a.show_email == true" :href="'mailto:'+a.email"><i class="far fa-envelope"></i><span>E-mail</span></a>
                                <a v-if="a.www && a.show_www == true" :href="a.www"><i class="far fa-file-code"></i><span>WWW</span></a>
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-9">
                        <p class="font-weight-bold text-6 text-uppercase"> 
                            {{ a.first_name }} {{ a.last_name }}
                        </p>
                        <div class="biography text-4 text-justify" v-html="a.biography"></div>
                    </div>
                </div>
            </div>
            <Partners />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Partners from '@/components/Partners.vue'
import { SpringSpinner } from 'epic-spinners'

export default {
    name: 'Lecture',
    components: {
        Partners,
        SpringSpinner
    },
    props: ['info'],
    data(){
        return{
            author: '',
            authors: '',
            authorsTemp: '',
            filesTemp: '',
            details: this.$route.params.id,
            name: '',
            image: '',
            lecture: '',
            ext: '',
            show_rate: '',
            show_points: '',
            ready: false,
            base: false,
        }
    }, 
    methods:{
        getName(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/lectures?fields=*.*&filter[slug]='+this.details)
                .then(response => {
                    this.lecture = response.data.data;
                    this.show_rate = response.data.data[0].edition.show_rate_lecture;
                    this.show_points = response.data.data[0].edition.show_nokia_points;
                })
                .then(response => {
                    for(let i = 0; i < this.lecture[0].lectures_authors.length;i++){
                        this.authorsTemp += this.lecture[0].lectures_authors[i].authors_id+ ','
                    }                    
                })
                .then(response => {
                    if(this.lecture[0].slides != null){
                        this.lecture[0].ext = this.lecture[0].slides.split('.').pop();
                    }
                })
                .then(response => {  
                    axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/authors?filter[id][in]='+this.authorsTemp)
                        .then(response => {
                            this.author = response.data.data;
                        })
                        .then(response => { 
                            for(let i = 0; i < this.lecture[0].lectures_authors.length;i++){
                                this.filesTemp += this.author[i].image+ ','
                            } 
                        })
                        .then(response => {
                            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/files?filter[id][in]='+this.filesTemp)
                                .then(response => { 
                                    for(let i = 0; i < this.lecture[0].lectures_authors.length;i++){
                                        this.author[i].image_full_url = response.data.data[i].data.full_url
                                    } 
                                })
                        })
                })
                .then(response => {
                    this.base = true;   
                })
        },
    },
    watch: {
        base: function(val) {
            setTimeout(()=>{
                this.ready = true;   
            },1000); 
        }
    },
    created(){
        this.getName();
    },
}
</script>